import { Address } from 'viem';
import { GetOrderListBookFilter } from './get-order-list-book';
import { GetUserOrdersFilter } from './get-user-order-vmm';
import { GetVMMPositionParams } from './get-postion-vmm';
import { GetVMMTradeHistoryParams } from './get-trade-histories';
import { GetAllUserOrdersParams } from './get-all-user-orders';

export const orderKeys = {
  all: ['order'] as const,

  orderListBookLists: () => [...orderKeys.all, 'orderListBook'] as const,
  orderListBook: (filter: GetOrderListBookFilter) =>
    [...orderKeys.orderListBookLists(), filter] as const,
  userOrdersKey: () => [...orderKeys.all, 'userOrders'] as const,
  userOrders: (userId: string) => [...orderKeys.userOrdersKey(), userId] as const,
  supportedPairs: () => [...orderKeys.all, 'supportedPairs'] as const,

  postions: () => [...orderKeys.all, 'postions'] as const,
  position: (walletAddress: Address) => [...orderKeys.postions(), walletAddress] as const,
  positionVmm: (params: GetVMMPositionParams) =>
    [...orderKeys.all, 'positionVmm', params.page, params.pageSize] as const,

  userOrdersVMMKey: () => [...orderKeys.all, 'userOrdersVMM'] as const,
  userOrdersVMM: (params?: GetUserOrdersFilter) =>
    [...orderKeys.userOrdersVMMKey(), params?.page, params?.pageSize] as const,

  executedOrdersKey: (params: GetVMMTradeHistoryParams) =>
    [...orderKeys.all, 'executedOrders', params.page, params.pageSize] as const,

  allUserOrdersKey: () => [...orderKeys.all, 'allUserOrders'] as const,
  allUserOrders: (params: GetAllUserOrdersParams) => [...orderKeys.allUserOrdersKey(), params.userId, params.page, params.pageSize, params.status] as const,

  availableMargin: (positionId: string) =>
    [...orderKeys.all, 'availableMargin', positionId] as const,
};
